import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Identities } from "./screens/identities";
import Login from "./screens/login";
import { ProtectedRoute, UnProtectedRoute } from "./components/protectedRoute";
import { Error404 } from "./screens/Error404";
import { Identity } from "./screens/identity";
import "./index.css";
import { LogoScreen } from "./screens/logoscreen";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <UnProtectedRoute>
              <LogoScreen />
            </UnProtectedRoute>
          }
        />
        <Route
          path="/identities"
          element={
            <ProtectedRoute>
              <Identities />
            </ProtectedRoute>
          }
        />
        <Route path="/:code" element={<Identity />} />
        <Route
          path="/admin"
          element={
            <UnProtectedRoute>
              <Login />
            </UnProtectedRoute>
          }
        />

        <Route path="/error" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

export default App;
